<div class="flex h-full w-full flex-col gap-2">
  <div class="grid grid-cols-4 items-center justify-items-start gap-1">
    <p-button label="Carica video"
              [disabled]="timerTick().playing"
              (onClick)="fileInput.click()">
    </p-button>
    <label>Inizio: {{ formatTime(videoStartMs) }}</label>
    <label>Durata: {{ formatDuration(videoDurationMs) }}</label>

      <input #fileInput
             type="file"
             accept="video/*"
             class="hidden"
             (change)="onFileSelected($event)"
             [disabled]="timerTick().playing" />
</div>

  <div *ngIf="!videoUrl"
       class="flex h-full w-full flex-col items-center justify-center rounded-lg border border-gray-300 bg-gray-50 text-gray-500">
    <i class="fas fa-video mb-4 text-5xl"></i>
    <p>Nessun video caricato</p>
    <p class="text-sm">Seleziona un file per iniziare la riproduzione</p>
  </div>
  <div *ngIf="videoUrl" class="flex h-full w-full flex-col">
    <video #videoRef
           [src]="videoUrl"
           (loadedmetadata)="onMetadataLoaded()"
           class="h-full w-full">
    </video>
  </div>
</div>

<p-dialog header="Header"
          [(visible)]="showDialog"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false">
  <ng-template pTemplate="header">
    <div class="flex w-full flex-col justify-center gap-3">
      <label class="font-bold">Orario di inizio del video</label>
      <hr />
    </div>
  </ng-template>

  <div class="flex flex-col">
    <p-datepicker [(ngModel)]="startTime" [timeOnly]="true"  [showSeconds]="true" placeholder="hh:mm:ss"
                  appendTo="body"/>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Chiudi"
              severity="secondary"
              variant="outlined"
              (click)="onCloseDialog()" />
    <p-button label="Carica"
              (click)="onTimeSelected()" />
  </ng-template>
</p-dialog>
